import cn from 'classnames';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import calendarIcon from 'assets/images/properties/calendar-event.svg';
import { ReturnComponentType } from 'common';
import { CommonDataCard } from 'components';
import { DateFormat, Paths } from 'enums';
import { InspectionType } from 'state';
import { FeedsType } from 'state/reducers/properties/types';
import './FeedInspection.scss';

type FeedInspectionType = {
  feed: FeedsType;
  className?: string;
};

export const FeedInspection = ({
  feed,
  className,
}: FeedInspectionType): ReturnComponentType => {
  const navigate = useNavigate();

  const onInspectionClick = () => {
    if (feed?.inspectionId) {
      navigate(`${Paths.INSPECTIONS}/${feed?.inspectionId}`);
    }
  };

  const getStatus = (inspection: InspectionType | undefined) => {
    if (!inspection?.files) return null;
    const files = Object.keys(inspection.files)
      .map(k => inspection.files[k])
      .reduce((c, n) => c.concat(n), []);

    if (files.length === 0) return null;
    const completedFiles = files.filter(f => f.uploadCompleted).length;

    return completedFiles === files.length ? (
      <span className="status-success">Ready</span>
    ) : (
      <span className="status-pending">
        {completedFiles} / {files.length} files ready
      </span>
    );
  };

  return (
    <CommonDataCard
      className={cn('FeedInspection', !!feed?.inspectionId && 'FeedPointer', className)}
      onClick={onInspectionClick}
    >
      <>
        <section className="FeedInspection_Title">
          <span className="FeedInspection_Title_Dot" />
          {feed.name ?? '-'}
        </section>

        <section className="FeedInspection_Body">
          <img
            src={calendarIcon}
            alt="calendar-icon"
            className="FeedInspection_Body_Icon"
          />
          <div className="FeedInspection_Body_Date">
            {dayjs(feed?.createdAt).format(DateFormat.GENERAL)}
          </div>
          <div className="FeedInspection_Body_Status">{getStatus(feed.inspection)}</div>
        </section>
      </>
    </CommonDataCard>
  );
};
